import React from 'react';
import PropTypes from 'prop-types';

const ListingHeader = ({ categoryName, categoryCount }) => (
  <h2 className='del-plp-filters__header'>
    {categoryName}{' '}
    <span className='del-plp-filters__header-count'>({categoryCount})</span>
  </h2>
);

ListingHeader.propTypes = {
  categoryName: PropTypes.string,
  categoryCount: PropTypes.number,
};

ListingHeader.defaultProps = {
  categoryName: '',
  categoryCount: 0,
};

export default ListingHeader;
